import React, { useEffect, useState } from "react";
import {
  Typography,
  Container,
  Dialog,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Select,
} from "@material-ui/core";
import {
  PostVerificationSendEmail,
} from "../../services/ReasonService";
import {
  PutApplicationResetPassword,
} from "../../services/ApplicationCallsService";
import ico_pass_on from "../../assets/images/ico_pass_on.svg";
import ico_pass_off from "../../assets/images/ico_pass_off.svg";
import { CorreosButton } from "../CorreosButton/CorreosButton";
import { CommonStyles } from "../../commons/CommonStyles";
import { DialogStyles } from "../CommonComponents/Dialogs/DialogStyles";
import { UserVerificationsStyles } from "../UserVerifications/UserVerificationsStyles";
import { checkIsNullUndefined, getErrorMessage } from "../../commons/Utils";
import { useTranslation } from "react-i18next";

export function DialogResetPassword(props) {
  const { verifiedEmails, open, setOpen, setAlert } = props;
  const commonClasses = CommonStyles();
  const dialogClasses = DialogStyles();
  const classes = UserVerificationsStyles();
  const { t, i18n } = useTranslation();

  const [emailsVerified, setEmailsVerified] = useState([]);
  const [otp, setOtp] = useState();
  const [otpError, setOtpError] = useState(false);
  const [otpHelper, setOtpHelper] = useState();
  const [sendedEmail, setSendedEmail] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [checkPassword, setCheckPassword] = useState("");
  const [checkPasswordError, setCheckPasswordError] = useState(false);
  const [showCheckPassword, setShowCheckPassword] = useState(false);
  const [checkAllOk, setCheckAllOk] = useState(false);
  const [allOk, setAllOk] = useState(false);
  const [name, setName] = useState();

  useEffect(() => {
    if (verifiedEmails !== emailsVerified) {
      setEmailsVerified(verifiedEmails);
      if (verifiedEmails.length > 0) {
        setSelectedEmail(verifiedEmails[0].email);
      }
    }
  }, [verifiedEmails]);

  useEffect(() => {
    if (checkAllOk) {
      handleCheckAllOk();
    }
  }, [checkAllOk]);

  const finishOperation = (color, message) => {
    setAlert({
      open: true,
      color,
      message,
    });
  };

  const handleCancel = () => {
    setOpen(false);
    setOtp(null);
    setOtpError(false);
    setOtpHelper("");
    setSendedEmail(false);
    setConfirmed(false);
    setPassword("");
    setPasswordError(false);
    setCheckPassword("");
    setCheckPasswordError(false);
    setAllOk(false);
  };

  const handleSend = () => {
    PostVerificationSendEmail(selectedEmail).then((response) => {
      if (response && !response.Status) {
        setSendedEmail(true);
        setName(selectedEmail);
      } else {
        finishOperation("error", getErrorMessage(response, t));
      }
    });
  };

  const handleChange = (value) => {
    setSelectedEmail(value.target.value);
    setSendedEmail(false);
    setConfirmed(false);
  };

  const handleResetPassword = () => {
    PutApplicationResetPassword(name, password, checkPassword, otp).then(
      (response) => {
        if (response && !response.Status) {
          finishOperation("success", t("resetPasswordChanged"));
          handleCancel();
        } else {
          finishOperation("error", getErrorMessage(response, t));
        }
      }
    );
  };

  const handleChangeOtp = (otp) => {
    setOtp(otp);
    if (!checkIsNullUndefined(otp)) {
      setOtpError(false);
      setOtpHelper("");
    } else {
      setOtpError(true);
      setOtpHelper(t("required"));
    }
    setCheckAllOk(true);
  };

  const handleChangePassword = (value) => {
    const hasNumber = new RegExp("[0-9]");
    const hasUpperChar = new RegExp("[A-Z]");
    const hasLowerChar = new RegExp("[a-z]");
    const hasNumberCharacters = new RegExp(".{8,16}");
    const hasSimbols = new RegExp("[@#$%^&*_+=[{}|\\:',?/`~\"();.-]");
    const hasSimbol = !checkIsNullUndefined(value.target.value)
      ? value.target.value.indexOf("]")
      : -1;
    let okPass = hasNumberCharacters.test(value.target.value);
    let okCheckPass = true;
    if (okPass) {
      let flag = 0;
      if (hasNumber.test(value.target.value)) flag++;
      if (hasUpperChar.test(value.target.value)) flag++;
      if (hasLowerChar.test(value.target.value)) flag++;
      if (hasSimbols.test(value.target.value) || hasSimbol >= 0) flag++;
      if (flag < 3) okPass = false;
    }
    if (value.target.value === "") okPass = true;

    if (checkPassword !== "" && checkPassword === value.target.value) {
      okCheckPass = false;
    }
    setPassword(value.target.value);
    setPasswordError(!okPass);
    if (checkPassword !== "") {
      setCheckPasswordError(okCheckPass);
      setCheckAllOk(true);
    } else {
      setCheckAllOk(true);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChangeCheckPassword = (value) => {
    let flag = false;
    if (password !== "" && password !== value.target.value) flag = true;
    setCheckPassword(value.target.value);
    setCheckPasswordError(flag);
    setCheckAllOk(true);
  };

  const handleClickShowCheckPassword = () => {
    setShowCheckPassword(!showCheckPassword);
  };

  const handleMouseDownCheckPassword = (event) => {
    event.preventDefault();
  };

  const handleCheckAllOk = () => {
    if (
      checkIsNullUndefined(otp) ||
      checkIsNullUndefined(password) ||
      checkIsNullUndefined(checkPassword)
    ) {
      setAllOk(false);
    } else if (otpError || passwordError || checkPasswordError) {
      setAllOk(false);
    } else {
      setAllOk(true);
    }
    setCheckAllOk(false);
  };

  const handleGoBack = () => {
    setConfirmed(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={() => handleCancel()}
      PaperProps={{ classes: { root: dialogClasses.dialogWindow } }}
    >
      <Container className={commonClasses.dialogTitle}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h4" className={commonClasses.dialogTitleText}>
              {!confirmed ? t("resetPasswordSend") : t("resetPasswordChange")}
            </Typography>
          </Grid>
        </Grid>
      </Container>

      {confirmed ? (
        <Container className={commonClasses.dialogContainer}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                color="secondary"
                value={otp}
                onChange={(e) => handleChangeOtp(e.target.value)}
                variant="outlined"
                margin="normal"
                fullWidth
                name="Otp"
                autoFocus
                label={t("registerPageOtp")}
                type="text"
                id="Otp"
                error={otpError}
                helperText={otpHelper}
                required
                className={commonClasses.inputsStyle}
              />
            </Grid>
            <Grid style={{ margin: "1.5em" }} />
            <Grid item xs={12}>
              <TextField
                color="secondary"
                value={password}
                onInput={handleChangePassword}
                variant="outlined"
                fullWidth
                name="password"
                label={t("registerPagePassword")}
                type={showPassword ? "text" : "password"}
                id="password"
                error={passwordError}
                required
                InputProps={{
                  className: classes.underline,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? (
                          <img src={ico_pass_on} alt="pass_on" />
                        ) : (
                          <img src={ico_pass_off} alt="pass_off" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                className={commonClasses.inputsStyle}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                color="secondary"
                value={checkPassword}
                onInput={handleChangeCheckPassword}
                variant="outlined"
                fullWidth
                name="checkPassword"
                label={t("registerPageCheckPassword")}
                type={showCheckPassword ? "text" : "password"}
                id="checkPassword"
                error={checkPasswordError}
                required
                InputProps={{
                  className: classes.underline,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowCheckPassword}
                        onMouseDown={handleMouseDownCheckPassword}
                      >
                        {showCheckPassword ? (
                          <img src={ico_pass_on} alt="pass_on" />
                        ) : (
                          <img src={ico_pass_off} alt="pass_off" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                className={commonClasses.inputsStyle}
              />
            </Grid>
            {passwordError || checkPasswordError ? (
              <Grid item sm={12} xs={12} className={commonClasses.gridIdentity}>
                <Typography className={classes.errorText}>
                  {passwordError
                    ? t("registerPagePasswordError")
                    : t("registerPageCheckPasswordError")}
                </Typography>
              </Grid>
            ) : null}
          </Grid>
        </Container>
      ) : (
        <Container className={commonClasses.dialogContainer}>
          {verifiedEmails.length > 0 ? (
            <Grid container spacing={1}>
              <Grid item xs={10}>
                <Typography className={classes.dialogContentText} noWrap>
                  {t("resetPasswordSendEmail")}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <FormControl variant="filled" color="secondary" fullWidth className={commonClasses.inputsStyle}>
                  <InputLabel>{t("resetPasswordEmail")}</InputLabel>
                  <Select
                    native
                    label={t("resetPasswordEmail")}
                    value={selectedEmail}
                    onChange={(value) => handleChange(value)}
                  >
                    {verifiedEmails.map((email) => {
                      return (
                        <option key={email.id} value={email.email}>
                          {email.email}
                        </option>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3} className={classes.dialogSendIconContainer} style={{ margin: "auto" }}>
                <CorreosButton
                  color={sendedEmail ? "secondary" : "primary"}
                  variant={sendedEmail ? "outlined" : "contained"}
                  onClick={() => handleSend()}
                  style={{ width: "100%" }}
                >
                  {sendedEmail ? t("reSend") : t("send")}
                </CorreosButton>
              </Grid>
            </Grid>
          ) : null}        
        </Container>
      )}
      <Container className={commonClasses.dialogContainer}>
        <Grid container spacing={1}>
          <Grid
            container
            item
            xs={12}
            className={commonClasses.dialogButtonContainer}
          >
            <Grid item xs={6}>
              {confirmed ? (
                <CorreosButton
                  onClick={handleGoBack}
                  className={commonClasses.dialogButtonLeft}
                >
                  {t("backButton")}
                </CorreosButton>
              ) : (
                <CorreosButton
                  onClick={handleCancel}
                  className={commonClasses.dialogButtonLeft}
                >
                  {t("cancel")}
                </CorreosButton>
              )}
            </Grid>
            <Grid item xs={6}>
              {confirmed ? (
                <CorreosButton
                  variant="contained"
                  color="primary"
                  onClick={handleResetPassword}
                  className={commonClasses.dialogButtonRight}
                  disabled={!allOk}
                >
                  {t("accept")}
                </CorreosButton>
              ) : (
                <CorreosButton
                  variant="contained"
                  color="primary"
                  onClick={() => setConfirmed(true)}
                  className={commonClasses.dialogButtonRight}
                  disabled={!sendedEmail}
                >
                  {t("next")}
                </CorreosButton>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
}
